// Colores de plataformas
export const PLATFORM_COLORS = {
  'Netflix': '#E50914',
  'Prime Video': '#00A8E1',
  'HBO': '#5C2D91',
  'SkyShowtime': '#8A63D2',
  'Movistar+': '#000000',
  'Apple TV+': '#1D1D1F',
  'Disney+': '#118DF0',
  'Mubi': '#001F3F',
  'APK': '#3DDC84',
  'Filmin': '#0A6E3A',
};

// Texto claro/oscuro según plataforma
export const PLATFORM_TEXT = {
  'Netflix': '#fff',
  'Prime Video': '#fff',
  'HBO': '#fff',
  'SkyShowtime': '#fff',
  'Movistar+': '#fff',
  'Apple TV+': '#ddd',
  'Disney+': '#fff',
  'Mubi': '#fff',
  'APK': '#000',
  'Filmin': '#fff',
};

// Lista de plataformas para selects
export const PLATFORMS = [
  'Netflix', 'Prime Video', 'HBO', 'Disney+', 'Apple TV+',
  'SkyShowtime', 'Movistar+', 'Filmin', 'Mubi', 'APK'
];

// Parsear género (viene como "Drama, Thriller" de la BD)
export function parseGenres(genre) {
  if (!genre) return [];
  if (Array.isArray(genre)) return genre;
  return genre.split(',').map(g => g.trim()).filter(Boolean);
}

// Parsear ratings_json para sacar Rotten Tomatoes
export function parseRatings(ratingsJson) {
  if (!ratingsJson) return {};
  try {
    const arr = typeof ratingsJson === 'string' ? JSON.parse(ratingsJson) : ratingsJson;
    if (!Array.isArray(arr)) return {};
    const result = {};
    arr.forEach(r => {
      if (r.Source === 'Internet Movie Database') result.imdb = r.Value;
      if (r.Source === 'Rotten Tomatoes') result.rt = r.Value;
      if (r.Source === 'Metacritic') result.mc = r.Value;
    });
    return result;
  } catch { return {}; }
}

// Credenciales login (hardcoded — protección básica, no seguridad real)
export const AUTH = {
  user: 'denis',
  pass: 'Villeneuve2026',
  storageKey: 'mycinema_auth',
  sessionDays: 30,
};
